import { de } from '@fsv/core';
import { Icon } from '../components/Icon';
import { DataError } from '@fsv/data';
import { errorMessage } from '../data/hooks';
import { tx } from '@fsv/data';

export function Loading({ label = tx.app.loading }: { label?: string }) {
  return (
    <p className="loading" role="status" aria-live="polite">
      {label}
    </p>
  );
}

/**
 * Not found (404: missing, deleted or another club's — the API does not say
 * which) gets no retry button, asking again changes nothing; offline (0)
 * says so and offers it.
 */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const status = error instanceof DataError ? error.status : null;
  return (
    <div className={`notice notice--error${status === 404 ? ' notice--notfound' : ''}`} role="alert">
      <Icon name={status === 0 ? 'offline' : 'alert'} />
      <div className="stack">
        <p>{errorMessage(error) || de.errors.generic}</p>
        {onRetry && status !== 404 && (
          <button type="button" className="btn" onClick={onRetry}>
            <Icon name="refresh" />
            {tx.app.retry}
          </button>
        )}
      </div>
    </div>
  );
}
